import http from "../utils/http-common";
const baseMasterPath = "/api/my-tasks";

export const getMyTasks = () => {
  return http.get(baseMasterPath);
};
